import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-carbon border-t border-carbon-lighter pt-20 pb-10 px-6" data-id="element-97">
      <div className="max-w-7xl mx-auto" data-id="element-98">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-99">
          {/* Column 1: Brand */}
          <div className="space-y-6" data-id="element-100">
            <img src="https://cdn.magicpatterns.com/uploads/qpWgoNVWVcrUCFCkMWmcru/IMG_6635.jpg" alt="Doctor Ecommerce Logo" className="h-12 object-contain" data-id="element-101" />
            <h3 className="font-heading text-xl font-bold text-gold" data-id="element-102">
              La cura para negocios estancados.
            </h3>
            <p className="text-neutral-400 font-body text-sm leading-relaxed" data-id="element-103">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Con sede estratégica en Tampa,
              Florida, servimos a dueños de negocios en todo Estados Unidos,
              transformando presupuestos publicitarios en máquinas de generación
              de llamadas y ventas diarias.
            </p>
          </div>

          {/* Column 2: Services */}
          <div data-id="element-104">
            <h4 className="font-heading font-bold text-gold mb-6 uppercase tracking-wider text-sm" data-id="element-105">
              Servicios
            </h4>
            <ul className="space-y-4 text-neutral-300 font-body text-sm" data-id="element-106">
              <li className="hover:text-gold transition-colors cursor-pointer" data-id="element-107">
                Meta Ads · Google Ads · TikTok Ads · YouTube Ads
              </li>
              <li className="hover:text-gold transition-colors cursor-pointer" data-id="element-108">
                Email · SMS · Retargeting Automatizado
              </li>
              <li className="hover:text-gold transition-colors cursor-pointer" data-id="element-109">
                Automatización con IA para Ventas 24/7
              </li>
              <li className="hover:text-gold transition-colors cursor-pointer" data-id="element-110">
                Funnels Quirúrgicos por Industria
              </li>
              <li className="hover:text-gold transition-colors cursor-pointer" data-id="element-111">
                Blindaje Digital & Anti-Ban
              </li>
              <li className="hover:text-gold transition-colors cursor-pointer" data-id="element-112">
                CRM & Data Tracking Avanzado
              </li>
              <li className="hover:text-gold transition-colors cursor-pointer" data-id="element-113">
                Diseño Web · Landing Pages · CRO
              </li>
            </ul>
          </div>

          {/* Column 3: Resources */}
          <div data-id="element-114">
            <h4 className="font-heading font-bold text-gold mb-6 uppercase tracking-wider text-sm" data-id="element-115">
              Recursos
            </h4>
            <ul className="space-y-4 text-neutral-300 font-body text-sm" data-id="element-116">
              <li className="hover:text-gold transition-colors cursor-pointer flex items-center gap-2" data-id="element-117">
                <span className="text-gold text-xs" data-id="element-118">›</span> Blog de Estrategia
              </li>
              <li className="hover:text-gold transition-colors cursor-pointer flex items-center gap-2" data-id="element-119">
                <span className="text-gold text-xs" data-id="element-120">›</span> Casos de Éxito
              </li>
              <li className="hover:text-gold transition-colors cursor-pointer flex items-center gap-2" data-id="element-121">
                <span className="text-gold text-xs" data-id="element-122">›</span> Política de
                Privacidad
              </li>
              <li className="hover:text-gold transition-colors cursor-pointer flex items-center gap-2" data-id="element-123">
                <span className="text-gold text-xs" data-id="element-124">›</span> Términos y
                Condiciones
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div data-id="element-125">
            <h4 className="font-heading font-bold text-gold mb-6 uppercase tracking-wider text-sm" data-id="element-126">
              Contacto Directo
            </h4>
            <ul className="space-y-6 text-neutral-300 font-body text-sm" data-id="element-127">
              <li className="flex items-start gap-3" data-id="element-128">
                <MapPinIcon className="w-5 h-5 text-gold shrink-0" data-id="element-129" />
                <span data-id="element-130">1001 WATER ST, TAMPA FL 33602</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-131">
                <PhoneIcon className="w-5 h-5 text-gold shrink-0" data-id="element-132" />
                <span data-id="element-133">4028720639</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-134">
                <MailIcon className="w-5 h-5 text-gold shrink-0" data-id="element-135" />
                <span data-id="element-136">doctor.ecommerceus@gmail.com</span>
              </li>
            </ul>

            <a href="#contact-form" className="mt-8 inline-block w-full text-center bg-emerald hover:bg-emerald-600 text-white font-heading font-bold py-3 px-4 rounded transition-colors" data-id="element-137">
              Habla con un Especialista
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-carbon-lighter flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-138">
          <p className="text-neutral-500 font-body text-xs" data-id="element-139">
            © {new Date().getFullYear()} Doctor Ecommerce. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-4 opacity-50 grayscale" data-id="element-140">
            {/* Placeholder for partner logos from the image */}
            <div className="bg-white px-3 py-1 rounded text-xs text-black font-bold" data-id="element-141">
              Meta Partner
            </div>
            <div className="bg-white px-3 py-1 rounded text-xs text-black font-bold" data-id="element-142">
              Google Partner
            </div>
            <div className="bg-white px-3 py-1 rounded text-xs text-black font-bold" data-id="element-143">
              Shopify Expert
            </div>
          </div>
        </div>
      </div>
    </footer>;
}